import Marquee from "react-fast-marquee";

const ROW_A = [
  { src: "/gallery/aula.jpg", alt: "Lezione in aula treffe" },
  { src: "/gallery/aula-logo-treffe.jpg", alt: "Aula treffe con logo a parete e schermo per le lezioni" },
  { src: "/gallery/aha.jpg", alt: "Affiliazione American Heart Association" },
  { src: "/gallery/cpr-esterno.jpg", alt: "Esercitazione RCP all'aperto" },
  { src: "/gallery/cpr.jpg", alt: "Esercitazione pratica BLSD su manichino" },
  { src: "/gallery/aula-azienda.jpg", alt: "Corso di formazione per lavoratori" },
];
const ROW_B = [
  { src: "/gallery/antincendio.jpg", alt: "Prova pratica antincendio" },
  { src: "/gallery/dae.jpg", alt: "Defibrillatore DAE — progetto sedi aziendali" },
  { src: "/gallery/lezione-aula.jpg", alt: "Docente treffe durante una lezione in aula" },
  { src: "/gallery/cpr-istruttrice.jpg", alt: "Istruttrice durante esercitazione RCP" },
  { src: "/gallery/estintore.jpg", alt: "Prova pratica con estintore" },
  { src: "/gallery/vvf.jpg", alt: "Esercitazione antincendio Vigili del Fuoco" },
  { src: "/gallery/esercitazione.jpg", alt: "Formazione pratica con manichini" },
  { src: "/gallery/braccio.jpg", alt: "Addestramento medicazioni e primo soccorso" },
];

const Img = ({ src, alt }) => (
  <div className="mx-2 h-44 sm:h-52 md:h-64 shrink-0 overflow-hidden bg-brand-paper">
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className="h-full w-auto object-cover transition-transform duration-700 hover:scale-105"
    />
  </div>
);

export const ImageStrip = () => (
  <section data-testid="image-strip" className="py-8 bg-white overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill className="mb-4">
      {ROW_A.map((p, i) => <Img key={i} src={p.src} alt={p.alt} />)}
    </Marquee>
    <Marquee speed={40} gradient={false} autoFill direction="right">
      {ROW_B.map((p, i) => <Img key={i} src={p.src} alt={p.alt} />)}
    </Marquee>
  </section>
);
